import React from 'react'

export default function Header() {
  return (
    <>
        <h1 className="title">Tenzies</h1>
        <p className="summary">
            Roll until all dice are the same. <br />
            Click each dice to freeze it at its current value between rolls.
        </p>
    </>
  )
}
